import * as React from 'react';
import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
import { SelectWithoutOutline } from '@lean-body/components/atoms';
import { getFormattedToHyphenFormat } from '@lean-body/src/util';
export const DateSelectFormWithoutOutline = ({ currentValue, setCurrentValue }) => {
    const value = dayjs(currentValue);
    const [year, setYear] = useState('');
    const [month, setMonth] = useState('');
    const [day, setDay] = useState('');
    useEffect(() => {
        setYear(currentValue ? `${value.year()}` : '');
        setMonth(currentValue ? `${value.month() + 1}` : '');
        setDay(currentValue ? `${value.date()}` : '');
    }, [currentValue]);
    const changeYear = (event) => {
        setYear(event.target.value);
        setDate(event.target.value, month, day);
    };
    const changeMonth = (event) => {
        setMonth(event.target.value);
        setDate(year, event.target.value, day);
    };
    const changeDay = (event) => {
        setDay(event.target.value);
        setDate(year, month, event.target.value);
    };
    const setDate = (y, m, d) => {
        if (y && m && d) {
            setCurrentValue(getFormattedToHyphenFormat(y, m, d));
        }
        else {
            setCurrentValue('');
        }
    };
    const yearsList = () => {
        const yearsList = [{ value: '', name: '　' }];
        const YearLower = 1900;
        for (let year = dayjs().year(); year >= YearLower; year--) {
            yearsList.push({ value: `${year}`, name: `${year}` });
        }
        return yearsList;
    };
    const monthList = () => {
        const monthList = [{ value: '', name: '　' }];
        for (let month = 1; month <= 12; month++) {
            monthList.push({ value: `${month}`, name: `${month}` });
        }
        return monthList;
    };
    const dayList = () => {
        const dayList = [{ value: '', name: '　' }];
        for (let day = 1; day <= 31; day++) {
            dayList.push({ value: `${day}`, name: `${day}` });
        }
        return dayList;
    };
    return (React.createElement("div", { className: css(styles.container) },
        React.createElement(SelectWithoutOutline, { selectOptions: yearsList(), value: year, containerClassObject: styles.year, onChange: changeYear }),
        React.createElement("div", { className: css(styles.unitLabel) }, "\u5E74"),
        React.createElement(SelectWithoutOutline, { selectOptions: monthList(), value: month, containerClassObject: styles.month, onChange: changeMonth }),
        React.createElement("div", { className: css(styles.unitLabel) }, "\u6708"),
        React.createElement(SelectWithoutOutline, { selectOptions: dayList(), value: day, containerClassObject: styles.day, onChange: changeDay }),
        React.createElement("div", { className: css(styles.unitLabel) }, "\u65E5")));
};
const styles = StyleSheet.create({
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    year: {
        width: 90,
    },
    month: {
        width: 45,
    },
    day: {
        width: 45,
    },
    unitLabel: {
        color: Colors.Black,
        fontSize: 32,
        fontWeight: 'bold',
        lineHeight: '140%',
        letterSpacing: 2.56,
        paddingBottom: 22,
    },
});
